import { render, staticRenderFns } from "./TryAnotherMethod.vue?vue&type=template&id=95fdb5e6"
import script from "./TryAnotherMethod.vue?vue&type=script&lang=ts"
export * from "./TryAnotherMethod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports